import PropTypes from 'prop-types';

const Car = ({ color }) => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.29167 9.79167C2.29167 10.2337 2.46726 10.6576 2.77982 10.9702C3.09238 11.2827 3.51631 11.4583 3.95833 11.4583C4.40036 11.4583 4.82428 11.2827 5.13684 10.9702C5.4494 10.6576 5.625 10.2337 5.625 9.79167M2.29167 9.79167C2.29167 9.34964 2.46726 8.92572 2.77982 8.61316C3.09238 8.3006 3.51631 8.125 3.95833 8.125C4.40036 8.125 4.82428 8.3006 5.13684 8.61316C5.4494 8.92572 5.625 9.34964 5.625 9.79167M2.29167 9.79167H0.625V4.79167M5.625 9.79167H10.625M10.625 9.79167C10.625 10.2337 10.8006 10.6576 11.1132 10.9702C11.4257 11.2827 11.8496 11.4583 12.2917 11.4583C12.7337 11.4583 13.1576 11.2827 13.4702 10.9702C13.7827 10.6576 13.9583 10.2337 13.9583 9.79167M10.625 9.79167C10.625 9.34964 10.8006 8.92572 11.1132 8.61316C11.4257 8.3006 11.8496 8.125 12.2917 8.125C12.7337 8.125 13.1576 8.3006 13.4702 8.61316C13.7827 8.92572 13.9583 9.34964 13.9583 9.79167M13.9583 9.79167H15.625V6.45833C15.625 6.01631 15.4494 5.59238 15.1368 5.27982C14.8243 4.96726 14.4004 4.79167 13.9583 4.79167H13.125M0.625 4.79167L2.29167 0.625H9.79167L13.125 4.79167M0.625 4.79167H13.125M8.125 4.79167V0.625"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Car.propTypes = {
  color: PropTypes.string,
};

Car.defaultProps = {
  color: '#696F7C',
};

export default Car;
